export default "__VITE_ASSET__FWplEJet__"